import {Color} from "three";
import * as THREE from "three";

export const MATERIAL_PROPS_DB = [


    {
        materialName: "FloorMat",

        roughness: 0.40,
        // toneMapped:true,
    },

    {
        materialName: "GlassMat",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `GlassMat-MPM`,
                color: new THREE.Color(255, 255, 255),
                metalness: 0,
                roughness: 0,
                // alphaMap: texture,
                alphaTest: 0.5,
                envMap: envMap, //this.backgroundMap,
                envMapIntensity: .2,
                depthWrite: false,
                transmission: .7, // use material.transmission for glass materials
                opacity: 1, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true
            });
        },
    },

    {
        materialName: "VideoButtonBaseMat",

        envMapIntensity: 4.179193713700034,

    },

    /* {
         materialName: "UVT1Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT2Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT3Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT4Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT5Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT6Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT7Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT8Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT9Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT10Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT11Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT12Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT13Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT14Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT15Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT16Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT17Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT18Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT19Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT20Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT21Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT22Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT23Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT24Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT25Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT26Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT27Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT28Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT29Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT30Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT31Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT32Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT33Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT34Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT35Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT36Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT37Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT38Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT39Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT40Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT41Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT42Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT43Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT44Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT45Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT46Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT47Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT48Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT49Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT50Mat",
         toneMapped: 'N',
     },
     {
         materialName: "UVT51Mat",
         toneMapped: 'N',
     },

     {
         materialName: "I_UVT_01",
         toneMapped: 'N',
     },
 */
    {
        materialName: "I_UVT_01",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_02",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_03",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_04",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_05",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_06",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_07",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_08",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_09",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_10",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_11",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_12",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_13",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_14",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_15",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_16",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_17",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_18",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_19",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_20",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_21",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_22",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_23",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_24",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_25",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_26",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_27",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_28",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_29",
        toneMapped: 'N',
    },


    {
        materialName: "I_UVT_30",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_31",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_32",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_33",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_34",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_35",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_36",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_37",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_38",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_39",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_40",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_41",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_42",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_43",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_44",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_45",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_46",
        toneMapped: 'N',
    },

    {
        materialName: "I_UVT_50",
        toneMapped: 'N',
    },

    {
        materialName: "HDRISphereFrontMat",
        toneMapped: 'N',
    },

    {
        materialName: "HDRISphereBackMat",
        toneMapped: 'N',
    },


    {
        materialName: "WallsBottomMat",
        aOIntensity: 0.75,
        //envMapIntensity:4.819408855490087,

    },
    {
        materialName: "CeilingBottomMat",
        aOIntensity: 0.775,

    },
    {
        materialName: "CeilingTopMat",
        aOIntensity: 0.8,

    },
    {
        materialName: "BookShelvMat",
        aOIntensity: 0.6,

    },
    {
        materialName: "FloorBottomMat",
        aOIntensity: 0.75,
        roughness: 0.45,

    },
    {
        materialName: "WallsTopMat",
        aOIntensity: 0.75,

    },
    {
        materialName: "FloorTopMat",
        aOIntensity: 0.75,
        roughness: 0.45,

    },
    {
        materialName: "StairsWoodMat",
        aOIntensity: 0.65,

    },


    {
        materialName: "StairsHandle",
        aOIntensity: 0.75,

    },

    {
        materialName: "BookshelfMat",
        aOIntensity: 0.7580267558528427,

    },


    {
        materialName: "PullupMetalMat",
        envMapIntensity: 5.266455171235452,
        roughness: 0.10306918492727185,

    },
    {
        materialName: "BookShelfMat",
        aOIntensity: 0.6285263517427909,

    },


    {
        materialName: "TabletPlinthMat",
        aOIntensity: 0.6285263517427909,

    },


    {
        materialName: "I_UVT_49",

        envMapIntensity: 4,

    },
    {
        materialName: "I_UVT_47",

        envMapIntensity: 4,

    },
    {
        materialName: "I_UVT_48",

        envMapIntensity: 4,

    },

    {
        materialName:"I_UVT_51",
        aOIntensity:0.8201176299193762,
        toneMapped: 'N',
    },

    {
        materialName: "WoodFrameRomm13Mat",
        aOIntensity: 0.5327307126544983,

    },


    /*

    [
{
 materialName:"I_UVT_51",
aOIntensity:0.8201176299193762,
emmisiveColor:
 new Color( 0, 0, 0 ),
emmissiveIntensity:1,
envMapIntensity:0.8,
lightMapIntensity:1,
roughness:0.5,
toneMapped:false,
 },

 ]
     */


]


